export default function simulationOneForm() {
  const forms = document.querySelectorAll('[form][simulation]');
  if (!forms.length) return;

  const MIN_ABS = 35000;
  const MAX_ABS = 1000000;
  const totalRange = MAX_ABS - MIN_ABS;

  function formatCurrency(value) {
    if (value >= 1000000) {
      const millions = value / 1000000;
      return `${millions
        .toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 1 })
        .replace('.', ',')} mi`;
    } else if (value >= 10000) {
      const thousands = Math.floor(value / 1000);
      return `${thousands.toLocaleString('pt-BR')} mil`;
    } else if (value >= 1000) {
      // Entre 1.000 e 9.999: mostra com ponto (ex: 5.600)
      return value.toLocaleString('pt-BR');
    }
    return `${value.toLocaleString('pt-BR')}`;
  }

  function getPercentage(value) {
    return ((value - MIN_ABS) / totalRange) * 100;
  }

  let ranges = window.simulationRanges ?? {};
  if (typeof ranges === 'string') {
    try {
      ranges = JSON.parse(ranges);
    } catch (err) {
      console.error('simulationOneForm: erro ao parsear window.simulationRanges', err);
      ranges = {};
    }
  }

  // 🔁 Inicializa cada form de forma independente
  forms.forEach((form) => {
    // Define o plano inicial baseado no lastSimulation se existir
    const lastSim = ranges.lastSimulation;
    let selectPlanInput = 'CREDIT';
    
    if (lastSim && lastSim.plan_type) {
      selectPlanInput = lastSim.plan_type.toUpperCase();
    }

    const creditTab = form.querySelectorAll('[creditTab]');
    const installmentTab = form.querySelectorAll('[installmentTab]');
    const planInput = form.querySelectorAll('[planInput]');
    const allSliders = form.querySelectorAll('[data-range-slider]');
    
    // Aplica o estado inicial correto nas tabs
    if (selectPlanInput === 'CREDIT') {
      creditTab.forEach((t) => (t.dataset.state = 'active'));
      installmentTab.forEach((t) => (t.dataset.state = 'inactive'));
      planInput.forEach((input) => (input.value = 'CREDIT'));
    } else {
      installmentTab.forEach((t) => (t.dataset.state = 'active'));
      creditTab.forEach((t) => (t.dataset.state = 'inactive'));
      planInput.forEach((input) => (input.value = 'INSTALLMENT'));
    }

    const getSelectedConsortiumId = () => {
      // First try to find a checked radio button
      const checked = form.querySelector('input[name="id_consortium"]:checked');
      if (checked && checked.value) return String(checked.value);

      // Otherwise try to find a select dropdown
      const select = form.querySelector('select[data-consortium-select]');
      if (select && select.value) return String(select.value);

      return null;
    };

    const getSelectedPlanType = () => (selectPlanInput ?? 'CREDIT').toLowerCase();

    function updateRangeFill(slider) {
      const rangeMin = slider.querySelector('[data-range-min]');
      const rangeMax = slider.querySelector('[data-range-max]');
      const rangeFill = slider.querySelector('[data-range-fill]');

      // Calcula percentual baseado nos limites atuais do slider
      const currentMin = Number(rangeMin.min);
      const currentMax = Number(rangeMin.max);
      const currentRange = currentMax - currentMin;

      if (currentRange <= 0) return;

      const percentMin = ((Number(rangeMin.value) - currentMin) / currentRange) * 100;
      const percentMax = ((Number(rangeMax.value) - currentMin) / currentRange) * 100;

      rangeFill.style.left = percentMin + "%";
      rangeFill.style.width = (percentMax - percentMin) + "%";
    }


    const updateRangeValues = () => {
      const consortiumId = getSelectedConsortiumId();
      const planType = getSelectedPlanType();

      if (!consortiumId || !ranges[consortiumId]) return;

      const config = ranges[consortiumId][planType];
      if (!config) return;

      const lastSim = ranges.lastSimulation;
      const hasLastSimulation = lastSim && lastSim.plan_type === planType;

      allSliders.forEach((slider) => {
        const dataRangeMin = slider.querySelector('[data-range-min]');
        const dataRangeMax = slider.querySelector('[data-range-max]');
        const minValueLabel = slider.querySelector('[min-value-label]');
        const maxValueLabel = slider.querySelector('[max-value-label]');

        const safeMin = Number(config.min ?? 0);
        const safeMax = Number(config.max ?? safeMin);
        const range = safeMax - safeMin;

        let idealStep;
        if (range < 10000) {
          idealStep = 100;
        } else {
          idealStep = Math.max(1000, Math.round(range / 100));
        }

        let minPercent = 0.2;
        let maxPercent = 0.8;

        if (!slider.dataset.init && hasLastSimulation) {
          const lastMin = Number(lastSim.min ?? 0);
          const lastMax = Number(lastSim.max ?? 0);
          
          if (lastMin >= safeMin && lastMin <= safeMax) {
            minPercent = (lastMin - safeMin) / range;
          }
          if (lastMax >= safeMin && lastMax <= safeMax) {
            maxPercent = (lastMax - safeMin) / range;
          }
        } else if (slider.dataset.init) {
          const oldMin = Number(dataRangeMin.min);
          const oldMax = Number(dataRangeMin.max);
          const oldRange = oldMax - oldMin;

          if (oldRange > 0) {
            const currentMinVal = Number(dataRangeMin.value);
            const currentMaxVal = Number(dataRangeMax.value);

            minPercent = (currentMinVal - oldMin) / oldRange;
            maxPercent = (currentMaxVal - oldMin) / oldRange;

            minPercent = Math.max(0, Math.min(1, minPercent));
            maxPercent = Math.max(0, Math.min(1, maxPercent));
          }
        }

        if (safeMax >= 1000000) {
          const targetValue = 600000;
          maxPercent = (targetValue - safeMin) / range;
          maxPercent = Math.max(0, Math.min(1, maxPercent));
        } else if (slider.dataset.init) {
          // 🔧 NOVO: Se já foi inicializado E o max é menor que 1mi, reseta para padrão
          minPercent = 0.2;
          maxPercent = 0.8;
        }

        dataRangeMin.min = safeMin;
        dataRangeMin.max = safeMax;
        dataRangeMin.step = idealStep;
        dataRangeMax.min = safeMin;
        dataRangeMax.max = safeMax;
        dataRangeMax.step = idealStep;

        const newMinVal = Math.floor(safeMin + range * minPercent);
        const newMaxVal = Math.floor(safeMin + range * maxPercent);

        dataRangeMin.value = newMinVal;
        dataRangeMax.value = newMaxVal;

        if (Number(dataRangeMin.value) >= Number(dataRangeMax.value)) {
          dataRangeMin.value = Math.floor(safeMin + range * 0.2);
          dataRangeMax.value = Math.floor(safeMin + range * 0.8);
        }

        slider.dataset.init = "true";

        minValueLabel.textContent = config.labelMin ?? formatCurrency(safeMin);
        maxValueLabel.textContent = config.labelMax ?? formatCurrency(safeMax);

        updateRangeFill(slider);
      });
    };

    function initRangeSlider(sliderWrapper) {
      const rangeMinInput = sliderWrapper.querySelector('[data-range-min]');
      const rangeMaxInput = sliderWrapper.querySelector('[data-range-max]');
      const rangeFill = sliderWrapper.querySelector('[data-range-fill]');
      const tooltipMin = sliderWrapper.querySelector('[data-tooltip-min]');
      const tooltipMax = sliderWrapper.querySelector('[data-tooltip-max]');

      if (!rangeMinInput || !rangeMaxInput || !rangeFill || !tooltipMin || !tooltipMax) return;

      let hasMinInteracted = false;
      let hasMaxInteracted = false;

      function updateSlider() {
        let minVal = parseInt(rangeMinInput.value);
        let maxVal = parseInt(rangeMaxInput.value);

        if (minVal > maxVal) {
          [minVal, maxVal] = [maxVal, minVal];
          rangeMinInput.value = minVal;
          rangeMaxInput.value = maxVal;
        }

        // Calcula percentual baseado nos limites atuais do slider
        const currentMin = Number(rangeMinInput.min);
        const currentMax = Number(rangeMinInput.max);
        const currentRange = currentMax - currentMin;

        const percentageMin = currentRange > 0 ? ((minVal - currentMin) / currentRange) * 100 : 0;
        const percentageMax = currentRange > 0 ? ((maxVal - currentMin) / currentRange) * 100 : 100;

        rangeFill.style.left = percentageMin + '%';
        rangeFill.style.width = percentageMax - percentageMin + '%';

        tooltipMin.textContent = formatCurrency(minVal);
        tooltipMax.textContent = formatCurrency(maxVal);

        tooltipMin.style.left = percentageMin + '%';
        tooltipMax.style.left = percentageMax + '%';
      }

      function setTooltipVisibility(tooltipElement, isVisible) {
        if (tooltipElement) {
          tooltipElement.classList.toggle('is-visible', isVisible);
        }
      }

      rangeMinInput.addEventListener('input', updateSlider);
      rangeMinInput.addEventListener('mousedown', () => setTooltipVisibility(tooltipMin, true));
      rangeMinInput.addEventListener('touchstart', () => setTooltipVisibility(tooltipMin, true));
      rangeMinInput.addEventListener('mouseup', () => (hasMinInteracted = true));
      rangeMinInput.addEventListener('touchend', () => (hasMinInteracted = true));
      rangeMinInput.addEventListener('blur', () => {
        if (!hasMinInteracted) setTooltipVisibility(tooltipMin, false);
      });

      rangeMaxInput.addEventListener('input', updateSlider);
      rangeMaxInput.addEventListener('mousedown', () => setTooltipVisibility(tooltipMax, true));
      rangeMaxInput.addEventListener('touchstart', () => setTooltipVisibility(tooltipMax, true));
      rangeMaxInput.addEventListener('mouseup', () => (hasMaxInteracted = true));
      rangeMaxInput.addEventListener('touchend', () => (hasMaxInteracted = true));
      rangeMaxInput.addEventListener('blur', () => {
        if (!hasMaxInteracted) setTooltipVisibility(tooltipMax, false);
      });

      updateSlider();
      updateRangeValues();
    }

    allSliders.forEach((slider) => initRangeSlider(slider));

    const handleTabClick = (tab) => {
      if (tab === 'credit') {
        creditTab.forEach((t) => (t.dataset.state = 'active'));
        installmentTab.forEach((t) => (t.dataset.state = 'inactive'));
        selectPlanInput = 'CREDIT';
        planInput.forEach((input) => (input.value = 'CREDIT'));
      } else {
        installmentTab.forEach((t) => (t.dataset.state = 'active'));
        creditTab.forEach((t) => (t.dataset.state = 'inactive'));
        selectPlanInput = 'INSTALLMENT';
        planInput.forEach((input) => (input.value = 'INSTALLMENT'));
      }
      updateRangeValues();
    };

    creditTab.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        handleTabClick('credit');
      });
    });

    installmentTab.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        handleTabClick('installment');
      });
    });

    // Atualiza ícones de consórcios
    form.querySelectorAll('.label-form-simulation')?.forEach((label) => {
      const input = label.querySelector('input[type="radio"]');
      const object = label.querySelector('object');

      if (!input || !object) return;

      const updateIconFill = () => {
        const svgDoc = object.contentDocument;
        if (!svgDoc) return;
        const paths = svgDoc.querySelectorAll('path');
        paths.forEach((p) => p.setAttribute('fill', input.checked ? '#04243B' : '#09A7DA'));
      };

      object.addEventListener('load', updateIconFill);

      if (input.checked) {
        if (object.contentDocument) updateIconFill();
        else object.addEventListener('load', updateIconFill, { once: true });
      }

      input.addEventListener('change', () => {
        const groupName = input.name;
        const groupInputs = form.querySelectorAll(`input[name="${groupName}"]`);
        groupInputs.forEach((i) => {
          const lbl = i.closest('.label-form-simulation');
          const obj = lbl?.querySelector('object');
          if (!obj || !obj.contentDocument) return;
          const paths = obj.contentDocument.querySelectorAll('path');
          paths.forEach((p) =>
            p.setAttribute('fill', i.checked ? '#04243B' : '#09A7DA')
          );
        });
        if (input.type !== 'range') {
          updateRangeValues();
        }
      });
    });

    // Listen for consortium select changes
    const consortiumSelect = form.querySelector('select[data-consortium-select]');
    if (consortiumSelect) {
      consortiumSelect.addEventListener('change', () => {
        updateRangeValues();
      });
    }

    // Inicializa o form no estado inicial correto
    updateRangeValues();
  });



  function changeCardsTextOnMobile() {
    const isMobile = window.innerWidth < 992;
    const cards = document.querySelectorAll('.label-form-simulation');

    if (cards.length === 0) return;

    cards.forEach((card, i) => {
      const textToChange = card.querySelector('.consortium-text');
      if (!textToChange) return;

      if (isMobile) {
        if (i === 0) {
          textToChange.textContent = "Veículo";
        } else if (i === 1) {
          textToChange.textContent = "Casa";
        } else if (i === 2) {
          textToChange.textContent = "Investimento";
        } else if (i === 3) {
          textToChange.textContent = "Veículo";
        } else if (i === 4) {
          textToChange.textContent = "Casa";
        } else if (i === 5) {
          textToChange.textContent = "Investimento";
        }
      }
    });
  }

  changeCardsTextOnMobile();
  
  window.addEventListener('resize', changeCardsTextOnMobile);
}